import { fg } from '@atlassian/jira-feature-gating';

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default {
	get(): boolean {
		return fg('require_ai_enabled_for_jsm_virtual_agent');
	},
};
